<template>
  <el-dropdown trigger="click" placement="bottom" @command="apply">
    <span class="typography-dropdown__trigger">
      {{ activeItem.label }}
      <i class="el-icon-arrow-down el-icon--right"></i>
    </span>
    <el-dropdown-menu slot="dropdown" class="typography-dropdown__menu">
      <el-dropdown-item
        v-for="item in items"
        :key="item.key"
        :command="item.key"
        :class="{ 'is-active': isActive(item.key) }"
      >
        <component
          :is="item.tag"
          :class="item.class"
          class="typography-dropdown__preview"
        >
          {{ item.label }}
        </component>
      </el-dropdown-item>
    </el-dropdown-menu>
  </el-dropdown>
</template>

<script>
import { Dropdown, DropdownMenu, DropdownItem } from "element-ui";

export default {
  name: "TypographyDropdown",

  components: {
    [Dropdown.name]: Dropdown,
    [DropdownMenu.name]: DropdownMenu,
    [DropdownItem.name]: DropdownItem,
  },

  props: {
    editorContext: {
      type: Object,
      required: true,
    },
  },

  computed: {
    editor() {
      return this.editorContext.editor;
    },

    // "Body" is just the plain paragraph node - it isn't one of the
    // configured Typography variants, so it's added here explicitly.
    items() {
      const variants = this.editor.extensions.options.typography.variants;
      return [{ key: "body", label: "Body", tag: "p", class: null }, ...variants];
    },

    activeItem() {
      return this.items.find((item) => this.isActive(item.key)) || this.items[0];
    },
  },

  methods: {
    isActive(key) {
      if (key === "body") return this.editorContext.isActive.paragraph();
      return this.editorContext.isActive.typography({ variant: key });
    },

    apply(key) {
      if (key === "body") {
        this.editorContext.commands.paragraph();
      } else {
        this.editorContext.commands.typography({ variant: key });
      }
    },
  },
};
</script>

<style scoped>
.typography-dropdown__trigger {
  display: inline-flex;
  align-items: center;
  height: 30px;
  padding: 0 8px;
  cursor: pointer;
  font-size: 13px;
  color: #515a6e;
}

.typography-dropdown__preview {
  margin: 0;
  display: inline-block;
}
</style>
